let key = {};
let env = "production";

// export const API_URL = "http://localhost:8113";
// export const API_URL = "https://sector8-backend.maticz.in/";//demo
export const API_URL = "https://api.sector-8.ch";


// if (process.env.NODE_ENV === "production") {
if (env === "production") {
  console.log("Set production Config");
  // const API_URL = "https://api.flashchainbot.com";
  const API_URL = "https://api.sector-8.ch";

  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: API_URL,
    FRONT_URL: "https://test.sector-8.ch",
    ADMIN_URL: "https://test-admin.sector-8.ch/",
    getGeoInfo: "https://ipapi.co/json/",
    ADMIN_WALLET: "0xe6978fC2B58478EFd66c88AED4fA5c625cb6Fcac",
  };
} else if (env === "demo") {
  console.log("Set Demo Config");
  const API_URL = "https://sector8-backend.maticz.in/";
  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: API_URL,
    FRONT_URL: "https://sector8.maticz.in/",
    ADMIN_URL: "https://sector8-admin.maticz.in/",
    getGeoInfo: "https://ipapi.co/json/",
    ADMIN_WALLET: "0xe6978fC2B58478EFd66c88AED4fA5c625cb6Fcac",
  };
} else {
  console.log("Set Development Config");
  const API_URL = "http://localhost";
  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: `${API_URL}:2026`,
    FRONT_URL: "http://localhost:3000",
    ADMIN_URL: "http://localhost:3001/admin",
    getGeoInfo: "https://ipapi.co/json/",
    ADMIN_WALLET: "0xe6978fC2B58478EFd66c88AED4fA5c625cb6Fcac",
  };
}

export default key;
